import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import CategorySlugPage from "@/pages/category/SlugPage";
import ArticlePage from "@/pages/article/page";
import ArticleSlugPage from "@/pages/article/SlugPage";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <CategoryPage />,
  },
  {
    path: "/category/:slug",
    element: <CategorySlugPage />,
  },
  {
    path: "/article",
    element: <ArticlePage />,
  },
  {
    path: "/article/:slug",
    element: <ArticleSlugPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;